import { combineReducers } from "redux";

import admin from "./admin";
import auth from "./auth";
import challenges from "./challenges";
import entry from "./entry";
import googleHelper from "./googleHelper";
import messages from "./messages";
import organisations from "./organisations";
import user from "./user";

const reducers = combineReducers({
  auth,
  user,
  messages,
  organisations,
  challenges,
  admin,
  entry,
  googleHelper,
});

export default reducers;
